module.exports = __webpack_public_path__ + "img/logo-mobile.ac2cbc56.svg";